import { render, staticRenderFns } from "./000_Sperrzone.vue?vue&type=template&id=66506f83&"
import script from "./000_Sperrzone.vue?vue&type=script&lang=js&"
export * from "./000_Sperrzone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports